import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { oidcAuthApi } from './oidcAuthApi';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    oidcAuthApi,
    SignInPageBlueprint.make({
      params: {
        loader: async () => {
          const { SignInPage } = await import('./SignInPage');
          return SignInPage;
        },
      },
    }),
  ],
});
